/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigNoContentResponse,
  BboBranchConfigUnauthorizedResponse,
  GetStockProductListForCountTypeParams,
  StockItemsList,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get product details for count type
 * @summary this endpoint is used to get the product details at particular accounting location based on count type
 */
export const getStockProductListForCountType = (
  params?: GetStockProductListForCountTypeParams,
  signal?: AbortSignal,
) => {
  return customInstance<StockItemsList | BboBranchConfigNoContentResponse>({
    url: `/BboBranchConfigService/v1/stock-product-list`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetStockProductListForCountTypeQueryKey = (
  params?: GetStockProductListForCountTypeParams,
) => {
  return [`/BboBranchConfigService/v1/stock-product-list`, ...(params ? [params] : [])] as const;
};

export const getGetStockProductListForCountTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockProductListForCountType>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  params?: GetStockProductListForCountTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockProductListForCountType>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockProductListForCountTypeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockProductListForCountType>>> = ({
    signal,
  }) => getStockProductListForCountType(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockProductListForCountType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockProductListForCountTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockProductListForCountType>>
>;
export type GetStockProductListForCountTypeQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary this endpoint is used to get the product details at particular accounting location based on count type
 */
export const useGetStockProductListForCountType = <
  TData = Awaited<ReturnType<typeof getStockProductListForCountType>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  params?: GetStockProductListForCountTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getStockProductListForCountType>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockProductListForCountTypeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
